import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getCachedAccessToken } from "shared/src/utils/cached-auth-session";
import { createEnhancedApolloErrorLink } from "./shared/apollo-error-link";

const graphQLUrl = import.meta.env.VITE_GRAPHQL_URL;

export const buildPublicUrl = (baseUrl: string): string =>
  baseUrl.replace(/\/+$/, "") + "-public";

const graphQLPublicUrl = buildPublicUrl(graphQLUrl);

const PUBLIC_OPERATIONS = [
  "UpdateAppealStatusWithToken",
  "CreateAppealStaging",
];

const authenticatedHttpLink = createHttpLink({ uri: graphQLUrl });
const publicHttpLink = createHttpLink({ uri: graphQLPublicUrl });

const authLink = setContext(async (_, { headers }) => {
  const token = await getCachedAccessToken();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const isPublicOperation = (operationName: string | undefined): boolean =>
  PUBLIC_OPERATIONS.includes(operationName ?? "");

const routingLink = ApolloLink.split(
  (operation) => isPublicOperation(operation.operationName),
  publicHttpLink,
  authLink.concat(authenticatedHttpLink),
);

const errorLink = createEnhancedApolloErrorLink();

const graphQLClient = new ApolloClient({
  cache: new InMemoryCache({}),
  link: errorLink.concat(routingLink),
  devtools: {
    enabled: false,
  },
});

export default graphQLClient;
